import type { ComponentType, LazyExoticComponent } from 'react';
import { lazy } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lazyNamed = <TKey extends string, TComponent extends ComponentType<any>>(
  factory: () => Promise<{ [key in TKey]: TComponent }>,
  name: TKey,
): LazyExoticComponent<TComponent> => lazy(() => factory().then((imported) => ({ default: imported[name] })));
